module.exports = __webpack_public_path__ + "img/black-overlay-right_blending.7cdcaf56.svg";